import { useEffect } from 'react'
import { X } from 'lucide-react'

export function LogoMark({ size = 38 }) {
  return (
    <svg className="logo-mark" width={size} height={size} viewBox="0 0 40 40" aria-hidden="true">
      <rect x="1.25" y="1.25" width="37.5" height="37.5" rx="10.5" fill="currentColor" opacity="0.12" />
      <path d="M10 10.8c0-1 .8-1.8 1.8-1.8h10.5l7.7 7.7v14.5c0 1-.8 1.8-1.8 1.8H11.8c-1 0-1.8-.8-1.8-1.8V10.8Z" fill="currentColor" opacity="0.92" />
      <path d="M22.6 9v6.2c0 1.2 1 2.1 2.1 2.1h5.3" fill="none" stroke="var(--paper, #fffdf8)" strokeWidth="1.65" strokeLinecap="round" />
      <path d="M15.2 22.2h9.8M15.2 26.2h7.2" stroke="var(--paper, #fffdf8)" strokeWidth="1.7" strokeLinecap="round" opacity="0.9" />
      <circle cx="30.7" cy="30.8" r="4.7" fill="#c76b50" stroke="#fffdf8" strokeWidth="2" />
    </svg>
  )
}

export function CoverArt({ project, variant = 'shelf' }) {
  const theme = project.theme || 'forest'
  const year = new Date(project.createdAt || Date.now()).getFullYear()
  return (
    <div className={'book-cover book-cover--' + theme + ' book-cover--' + variant}>
      <div className="book-cover__grain" />
      <div className="book-cover__spine" />
      <CoverMotif theme={theme} />
      <div className="book-cover__top">
        <span>页屿 · 手稿</span>
        <span>{project.type || '笔记本'}</span>
      </div>
      <div className="book-cover__center">
        <h3>{project.title}</h3>
        <p>{project.subtitle}</p>
      </div>
      <div className="book-cover__bottom">
        <span>PAGE ISLE PRESS</span>
        <span>{year}</span>
      </div>
    </div>
  )
}

function CoverMotif({ theme }) {
  if (theme === 'ochre') {
    return (
      <svg className="book-cover__motif" viewBox="0 0 300 380" fill="none" aria-hidden="true">
        <circle cx="240" cy="108" r="53" stroke="currentColor" strokeWidth="1.1" opacity="0.65" />
        <circle cx="240" cy="108" r="31" stroke="currentColor" strokeWidth="1.1" opacity="0.35" />
        <path d="M-20 300C70 250 128 334 214 292C258 270 289 270 330 287" stroke="currentColor" strokeWidth="1.1" opacity="0.55" />
        <path d="M-20 312C70 262 128 346 214 304C258 282 289 282 330 299" stroke="currentColor" strokeWidth="1.1" opacity="0.28" />
        <path d="M58 0V380M70 0V380" stroke="currentColor" strokeWidth="0.7" opacity="0.14" />
        <path d="M0 90H300M0 102H300" stroke="currentColor" strokeWidth="0.7" opacity="0.12" />
      </svg>
    )
  }
  if (theme === 'navy') {
    return (
      <svg className="book-cover__motif" viewBox="0 0 300 380" fill="none" aria-hidden="true">
        <circle cx="225" cy="120" r="78" stroke="currentColor" strokeWidth="1.1" opacity="0.55" />
        <circle cx="225" cy="120" r="55" stroke="currentColor" strokeWidth="1.1" opacity="0.34" />
        <circle cx="225" cy="120" r="31" stroke="currentColor" strokeWidth="1.1" opacity="0.22" />
        <circle cx="225" cy="120" r="4" fill="currentColor" opacity="0.8" />
        <path d="M38 264L278 214" stroke="currentColor" strokeWidth="1" opacity="0.4" />
        <path d="M52 282L292 232" stroke="currentColor" strokeWidth="1" opacity="0.2" />
        <path d="M0 322H300" stroke="currentColor" strokeWidth="0.8" opacity="0.25" />
      </svg>
    )
  }
  if (theme === 'clay') {
    return (
      <svg className="book-cover__motif" viewBox="0 0 300 380" fill="none" aria-hidden="true">
        <rect x="174" y="50" width="116" height="76" rx="2" stroke="currentColor" strokeWidth="1.1" opacity="0.45" transform="rotate(7 174 50)" />
        <path d="M180 119L232 78L280 123" stroke="currentColor" strokeWidth="1.1" opacity="0.42" transform="rotate(7 174 50)" />
        <circle cx="231" cy="159" r="28" stroke="currentColor" strokeWidth="0.9" opacity="0.28" />
        <path d="M218 159H244M231 146V172" stroke="currentColor" strokeWidth="0.8" opacity="0.25" />
        <path d="M-20 280C76 240 138 314 212 279C256 258 296 258 334 276" stroke="currentColor" strokeWidth="1.1" opacity="0.38" />
      </svg>
    )
  }
  return (
    <svg className="book-cover__motif" viewBox="0 0 300 380" fill="none" aria-hidden="true">
      <circle cx="234" cy="103" r="46" fill="currentColor" opacity="0.1" />
      <circle cx="234" cy="103" r="28" stroke="currentColor" strokeWidth="1" opacity="0.45" />
      <path d="M-24 276C58 231 104 310 176 275C220 252 264 251 330 278" stroke="currentColor" strokeWidth="1.2" opacity="0.58" />
      <path d="M-24 292C58 247 104 326 176 291C220 268 264 267 330 294" stroke="currentColor" strokeWidth="1" opacity="0.34" />
      <path d="M-24 308C58 263 104 342 176 307C220 284 264 283 330 310" stroke="currentColor" strokeWidth="0.9" opacity="0.18" />
      <path d="M0 144H300" stroke="currentColor" strokeWidth="0.8" opacity="0.14" />
      <path d="M0 156H300" stroke="currentColor" strokeWidth="0.8" opacity="0.09" />
    </svg>
  )
}

export function MiniCover({ project, size = 42 }) {
  return (
    <div className={'mini-cover mini-cover--' + (project.theme || 'forest')} style={{ width: size, height: size * 1.24 }} aria-hidden="true">
      <span />
      <i />
    </div>
  )
}

export function Avatar({ name = '林', size = 34, tone = 'ink' }) {
  return (
    <span className={'avatar avatar--' + tone} style={{ width: size, height: size, fontSize: Math.max(11, size * 0.36) }}>
      {name}
    </span>
  )
}

export function ModalShell({ children, onClose, className = '', width = '860px' }) {
  useEffect(() => {
    const previous = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    function handleKeyDown(event) {
      if (event.key === 'Escape') onClose()
    }
    window.addEventListener('keydown', handleKeyDown)
    return () => {
      window.removeEventListener('keydown', handleKeyDown)
      document.body.style.overflow = previous
    }
  }, [onClose])

  return (
    <div className="modal-backdrop" onMouseDown={(event) => { if (event.target === event.currentTarget) onClose() }}>
      <div className={'modal-shell ' + className} style={{ width }} role="dialog" aria-modal="true">
        <button className="modal-close" onClick={onClose} aria-label="关闭">
          <X size={18} />
        </button>
        {children}
      </div>
    </div>
  )
}

export function FieldLabel({ children, hint }) {
  return (
    <div className="field-label">
      <span>{children}</span>
      {hint ? <em>{hint}</em> : null}
    </div>
  )
}

export function EmptyState({ icon, title, text, action }) {
  return (
    <div className="empty-state">
      <div className="empty-state__icon">{icon}</div>
      <h4>{title}</h4>
      <p>{text}</p>
      {action}
    </div>
  )
}
